import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-graphic',
  templateUrl: './graphic.component.html',
  styleUrls: ['./graphic.component.sass']
})
export class GraphicComponent implements OnInit {
  public tabActive = 'usage';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  @Input() indexI;
  @Input() indexJ;
  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  public info = [];
  public productTypeField = [];
  public packagesBase = [];
  public dataInternal = 1;
  public usage2: any;
  public mixed = false;
  constructor(private router: Router, private global: GlobalService, public dialog: MatDialog, private route: ActivatedRoute) { }
  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.usage_info();
    this.loadCanvas();
    this.dataInternal;
    this.mixed;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  usage_info() {
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    for (var i = 0; i < this.info.length; i++) {
      this.check(this.info[i].productTypeField);
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[i].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
         
          //alert(offers.usedField +" == "+offers.quotaField)
          
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
         // percentage=Math.round(percentage);

          if(iDLocal==0){
            percentage = 0;
          }
          
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if (offers.offerGroupField.search("NT_ROAM_GRANEL") > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[i].productTypeField + '"';
      usage += '}';
      counter1++;
    }
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  initializeData() {

  }
  loadCanvas() {
    let objHtml;
    for (let i = 0; i < this.usage2.length; i++) {
      for (let j = 0; j < this.usage2[i].subscriber.length; j++) {
        objHtml = 'idCanvasPaq_' + i + '_' + j;
        this.global.pid2D(document.getElementById(objHtml), this.usage2[i].subscriber[j].percentage);
      }
    }
  }
  ngAfterViewInit(): void {
    this.loadCanvas();
  }
}
